import axios from 'axios';
export default {
    getData: (path) => {
        return axios.get(path)
        .then(payload => payload.data)
        .catch(function (error) {
            return Promise.reject(error.response);
        });
    },
    postData: (path, data, config=null) => {
        return axios.post(path, data, config)
        .then(payload => payload.data)
        .catch(function (error) {
            return Promise.reject(error.response);
        });
    },
    postDataForm: (path, data) => {
        const params = [];
        for (const property in data) {
            params.push(property + '=' + data[property])
        }
        const options = {
            method: 'POST',
            headers: {'content-type': 'application/x-www-form-urlencoded'},
            data: params.join('&'),
            url: path,
        };
        return axios(options)
            .then(payload => payload.data)
            .catch(function (error) {
                return Promise.reject(error.response);
            });
    }
};



// WEBPACK FOOTER //
// ./src/api/data.js